import { JetView } from 'webix-jet';
import { devConfig, countries, walletsList, profile } from 'config/config';

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the layout of the FilterBetsReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size;

        // Left section containing filters
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'DateStart',
                            id: 'DateStart',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'DateEnd',
                            id: 'DateEnd',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Expiración'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                {
                                    id: 'C',
                                    value: _('Abierto'),
                                },
                                {
                                    id: 'S',
                                    value: _('Ganó'),
                                },
                                {
                                    id: 'N',
                                    value: _('Perdió'),
                                },
                                {
                                    id: 'A',
                                    value: _('No Acción'),
                                },
                                {
                                    id: 'R',
                                    value: _('Pendiente'),
                                },
                                {
                                    id: 'W',
                                    value: _('En Espera'),
                                },
                                {
                                    id: 'J',
                                    value: _('Rechazada'),
                                },
                                {
                                    id: 'M',
                                    value: _('Rechazada por Regla'),
                                },
                                {
                                    id: 'T',
                                    value: _('Retiro Voluntario'),
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'PlayerId',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Id'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Id '),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                        },
                        {
                            view: 'text',
                            name: 'TicketId',
                            minWidth: 200,
                            label: "<span class='icon-ticket'></span>" + _('Ticket Id'),
                            labelPosition: 'top',
                            placeholder: _('Ticket Id '),
                        },
                        {
                            view: 'text',
                            name: 'Ip',
                            minWidth: 200,
                            label: "<span class='icon-ip'></span>" + _('Dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '),
                        },
                        {
                            view: 'richselect',
                            name: 'TypeBet',
                            id: 'TypeBet',
                            minWidth: 200,
                            label: _('Tipo de Apuesta'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 2,
                            options: [
                                { id: '1', value: _('Apuestas Creadas') },
                                { id: '2', value: _('Apuestas Cerradas') },
                                { id: '3', value: _('Apuestas Pagadas') },
                                { id: '4', value: _('Apuestas Canceladas') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'TypeAwards',
                            id: 'TypeAwards',
                            minWidth: 200,
                            label: _('Tipo para Premios'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 2,
                            options: [
                                { id: '1', value: _('Apuestas Cerradas') },
                                { id: '2', value: _('Apuestas Pagadas') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    id: 'Sort',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Sort',
                            label: _('Ordenar por'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Fecha Creación') },
                                { id: '2', value: _('Usuario Id') },
                                { id: '3', value: _('Valor') },
                            ],
                            value: '1',
                        },
                        {
                            view: 'combo',
                            name: 'Dir',
                            label: _('Orden'),
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                { id: '0', value: _('Ascendente') },
                                { id: '1', value: _('Descendente') },
                            ],
                            value: '0',
                        },
                        {
                            view: 'combo',
                            name: 'WalletId',
                            minWidth: 200,
                            localId: 'wallet:combo',
                            label: _('Tipo de Billetera'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            suggest: walletsList,
                        },
                        {
                            view: 'checkbox',
                            label: _('Resumido'),
                            labelPosition: 'top',
                            name: 'IsDetails',
                            id: 'IsDetails',
                            value: 0,
                            minWidth: 200,
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    height: document.body.offsetWidth < 500 ? 80 : 0,
                    cols: [
                        {
                            view: 'text',
                            name: 'BetshopCreadted',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Creo'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Creo'),
                            hidden: !devConfig.getPermAction('filterByBetshopCreadted', 'Add'),
                            css: 'prm-filterByBetshopCreadted',
                        },
                        {
                            view: 'text',
                            name: 'BetshopPaid',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Pagó'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Pagó'),
                            hidden: !devConfig.getPermAction('filterByBetshopPaid', 'Add'),
                            css: 'prm-filterByBetshopPaid',
                        },
                        {
                            view: 'radio',
                            name: 'TypeUser',
                            label: _('Tipo de usuario'),
                            labelPosition: 'top',
                            value: 0,
                            options: [
                                { id: 0, value: _('Todos') },
                                {
                                    id: 1,
                                    value: "<span class='icon-players'></span> ",
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-shop'></span>",
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Right section containing additional filters
        const left2 = {
            margin: 5,
            id: 'b2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'text',
                            name: 'ValueMinimum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Premio Total Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Premio Total Mínimo'),
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Premio Total Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Premio Total Máximo'),
                        },
                    ],
                },
            ],
        };

        // Upper section containing the main filter layout
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section for additional filters
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('DateStart').setValue('');
                        $$('DateEnd').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        this.app.callEvent('casinoReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };

        // Accordion section for mobile view
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            view: 'button',
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultMobile',
                            click: () => {
                                const filterdata = this.getRoot().getValues();
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry;
                                }
                                delete filterdata['CountrySelect2'];
                                this.app.callEvent('casinoReport:filter', [filterdata]);
                                $$('b5').collapse();
                                $$('a5').scrollTo(100, 0);
                            },
                        },
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [accordion_section2],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the FilterBetsReportView.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        $$('TypeAwards').hide();
        $$('DateStart').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            if ($$('IsDetails').getValue() == '1') {
                $$('TypeAwards').show();
                $$('TypeBet').hide();
            } else {
                $$('TypeBet').show();
                $$('TypeAwards').hide();
            }
        });
        webix.ready(function () {
            $$('DateStart').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang);
            });
            $$('DateEnd').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang);
            });
            if (screen.width < 500) {
                $$('consultDesk').hide();
            }
            if (screen.width >= 500) {
                $$('consultMobile').hide();
            }
        });
    }
}

// FILE DOCUMENTED
